/**
 * File custom-javascript.js.
 *
 * Handles same-page anchor navigation with smooth scrolling offsets that
 * account for the fixed header and mobile Bootstrap navigation state.
 */
document.addEventListener("DOMContentLoaded", function () {
  var navbar = document.getElementById("primary-navbar");
  var navWrapper = document.getElementById("wrapper-navbar");
  var collapse = null;
  var logoSlidersVisible = true;

  document.addEventListener("visibilitychange", function () {
    logoSlidersVisible = !document.hidden;
  });

  function updateHeaderState() {
    if (!navWrapper) {
      return;
    }

    navWrapper.classList.toggle("scrolled", window.scrollY > 20);
  }

  window.addEventListener("scroll", updateHeaderState, { passive: true });
  window.addEventListener("resize", updateHeaderState);
  updateHeaderState();

  if (navbar && typeof bootstrap !== "undefined") {
    collapse = bootstrap.Collapse.getOrCreateInstance(navbar, {
      toggle: false,
    });
  }

  /**
   * Adjust the scroll position so hash targets stay visible below the header.
   */
  function getScrollOffset() {
    var navHeight = navWrapper ? navWrapper.offsetHeight : 0;

    if (window.innerWidth < 992) {
      return Math.max(navHeight - 28, 24);
    }

    return navHeight + 12;
  }

  /**
   * Scroll to a hash target — delegates to Lenis when available.
   */
  function scrollToHash(hash) {
    var target;

    try {
      target = document.querySelector(decodeURI(hash));
    } catch (e) {
      return;
    }

    if (!target) {
      return;
    }

    var offset = getScrollOffset();

    if (window.lenis && typeof window.lenis.scrollTo === "function") {
      window.lenis.scrollTo(target, {
        offset: -offset,
        duration: 1,
      });
      return;
    }

    var top =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      offset;

    window.scrollTo({
      top: top,
      behavior: "smooth",
    });
  }

  /**
   * Intercept same-page anchor clicks, letting the browser handle unknown
   * targets naturally.
   */
  document.querySelectorAll('a[href*="#"]').forEach(function (link) {
    link.addEventListener("click", function (event) {
      var href = link.getAttribute("href");

      if (!href || href === "#") {
        return;
      }

      var url;

      try {
        url = new URL(href, window.location.href);
      } catch (e) {
        return;
      }

      // Only intercept in-page anchor links that resolve on the current URL.
      if (
        url.origin !== window.location.origin ||
        url.pathname !== window.location.pathname ||
        !url.hash
      ) {
        return;
      }

      var target;

      try {
        target = document.querySelector(decodeURI(url.hash));
      } catch (e) {
        return;
      }

      if (!target) {
        return;
      }

      event.preventDefault();
      window.history.pushState(null, "", url.hash);

      if (
        collapse &&
        window.innerWidth < 992 &&
        navbar.contains(link) &&
        navbar.classList.contains("show")
      ) {
        collapse.hide();
        window.setTimeout(function () {
          scrollToHash(url.hash);
        }, 250);
        return;
      }

      scrollToHash(url.hash);
    });
  });

  if (window.location.hash) {
    window.setTimeout(function () {
      scrollToHash(window.location.hash);
    }, 50);
  }

  document
    .querySelectorAll(".d18-customer-grid.logo-slider-block")
    .forEach(function (block) {
      if (typeof Flickity === "undefined") {
        return;
      }

      block.querySelectorAll(".logo-slider").forEach(function (slider, index) {
        var flickity = new Flickity(slider, {
          cellAlign: "left",
          pageDots: false,
          prevNextButtons: false,
          imagesLoaded: true,
          wrapAround: true,
          selectedAttraction: 0.01,
          friction: 0.15,
        });

        window.setTimeout(function () {
          window.setInterval(function () {
            if (logoSlidersVisible) {
              flickity.next();
            }
          }, 4000);
        }, 750 * index);
      });
    });

});

// Scroll reveals.
//
// Deliberately its own listener rather than sharing the big DOMContentLoaded
// handler above: a decorative enhancement must not be able to be taken down by
// an unrelated failure earlier in that handler, and vice versa.
//
// A fade-and-rise is all the comp asks for, so this uses IntersectionObserver
// and a CSS transition rather than GSAP + ScrollTrigger (~110KB from a CDN for
// one effect). Elements opt in with .d18-reveal.
//
// The hero is deliberately never revealed: it is above the fold and holds the
// LCP image, so animating it would delay the largest paint for no gain.
(function () {
  var targets = document.querySelectorAll(".d18-reveal");

  if (!targets.length) {
    return;
  }

  function reveal(el) {
    if (el.classList.contains("is-revealed")) {
      return;
    }

    var group = el.querySelectorAll(".d18-reveal-item");

    // Stagger children so a row of cards arrives in sequence.
    Array.prototype.forEach.call(group, function (child, i) {
      child.style.transitionDelay = i * 80 + "ms";
    });

    el.classList.add("is-revealed");
  }

  function revealAll() {
    Array.prototype.forEach.call(targets, reveal);
  }

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)");

  // Show everything immediately when motion is reduced, or when the browser has
  // no IntersectionObserver.
  if (reduced.matches || !("IntersectionObserver" in window)) {
    revealAll();
    return;
  }

  // Safety net. These elements start at opacity 0, so anything that stops the
  // observer reporting - an embedding context that never runs the callback, a
  // future refactor, a script error between here and first paint - would leave
  // the page blank below the hero. Content visibility must not depend on an
  // animation succeeding, so reveal everything unconditionally after 2.5s; the
  // observer normally wins long before that.
  var safety = window.setTimeout(revealAll, 2500);

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: "0px 0px -12% 0px", threshold: 0.05 }
  );

  Array.prototype.forEach.call(targets, function (el) {
    observer.observe(el);
  });

  // Anything already on screen at load should not wait for a scroll.
  Array.prototype.forEach.call(targets, function (el) {
    var r = el.getBoundingClientRect();

    if (r.top < window.innerHeight && r.bottom > 0) {
      reveal(el);
      observer.unobserve(el);
    }
  });

  // Once the user has scrolled past everything, the net is no longer needed.
  window.addEventListener(
    "scroll",
    function () {
      var pending = document.querySelectorAll(".d18-reveal:not(.is-revealed)");

      if (!pending.length) {
        window.clearTimeout(safety);
      }
    },
    { passive: true }
  );
})();
